module.exports = __webpack_public_path__ + "json/buildings-4.json?96f0f30d87c840084c2b12feb8bcc907";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-4.json
// module id = 1723
// module chunks = 3